(function () {
  document.querySelectorAll('[data-sv-announcement-bar]').forEach(function (bar) {
    var slides = bar.querySelectorAll('[data-sv-announcement-slide]');
    if (slides.length < 2) return;

    var index = 0;
    var intervalId = null;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // Tracked independently — hover and keyboard focus can overlap (e.g. a
    // shopper tabs into a message's link while also hovering the bar), so
    // leaving one must not resume rotation while the other is still active.
    var hovering = false;
    var focused = false;

    function show(next) {
      slides[index].classList.remove('is-active');
      index = next;
      slides[index].classList.add('is-active');
    }

    function tick() {
      show((index + 1) % slides.length);
    }

    function start() {
      if (reducedMotion || intervalId || hovering || focused) return;
      intervalId = setInterval(tick, 4000);
    }

    function stop() {
      clearInterval(intervalId);
      intervalId = null;
    }

    bar.addEventListener('mouseenter', function () {
      hovering = true;
      stop();
    });
    bar.addEventListener('mouseleave', function () {
      hovering = false;
      start();
    });
    bar.addEventListener('focusin', function () {
      focused = true;
      stop();
    });
    bar.addEventListener('focusout', function () {
      focused = false;
      start();
    });

    start();
  });
})();
